// Wraps a formatter so negative values that round to zero display as "$0" instead of "-$0".
// Shadows `format` on the instance itself (rather than returning a new object) so the export
// stays a drop-in Intl.NumberFormat — resolvedOptions(), formatToParts(), etc. keep working.
const withoutNegativeZero = (
  formatter: Intl.NumberFormat,
): Intl.NumberFormat => {
  const nativeFormat = formatter.format.bind(formatter);
  Object.defineProperty(formatter, 'format', {
    value: (value: number): string => {
      const normalized = Object.is(value, -0) ? 0 : value;
      if (normalized >= 0) {
        return nativeFormat(normalized);
      }
      const digitParts = formatter
        .formatToParts(normalized)
        .filter((part) => part.type === 'integer' || part.type === 'fraction');
      const roundsToZero =
        digitParts.length > 0 &&
        digitParts.every((part) => /^0+$/.test(part.value));
      return nativeFormat(roundsToZero ? Math.abs(normalized) : normalized);
    },
  });
  return formatter;
};

export const formatUSD = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const formatUSDWhole = withoutNegativeZero(
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }),
);
